'use client';

import { c as _c } from "react/compiler-runtime";
import { useRef, type ReactNode } from 'react';
import { useMountEffect } from '@/hooks/useMountEffect';
import type { RotationAlbum } from '@/lib/rotation/types';
export function SpotifyLink(t0) {
  const $ = _c(8);
  const {
    album,
    children
  } = t0;
  const timer = useRef(undefined);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => () => clearTimeout(timer.current);
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  useMountEffect(t1);
  let t2;
  if ($[1] !== album.id || $[2] !== album.spotifyUrl) {
    t2 = event => {
      if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }
      event.preventDefault();
      clearTimeout(timer.current);
      const cancel = () => {
        if (document.hidden) {
          clearTimeout(timer.current);
        }
      };
      document.addEventListener("visibilitychange", cancel, {
        once: true
      });
      timer.current = setTimeout(() => {
        document.removeEventListener("visibilitychange", cancel);
        if (!document.hidden) {
          window.location.assign(album.spotifyUrl);
        }
      }, 1400);
      window.location.assign(`spotify:album:${album.id}`);
    };
    $[1] = album.id;
    $[2] = album.spotifyUrl;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== album.spotifyUrl || $[5] !== children || $[6] !== t2) {
    t3 = <a href={album.spotifyUrl} target="_blank" rel="noopener noreferrer" onClick={t2}>{children}</a>;
    $[4] = album.spotifyUrl;
    $[5] = children;
    $[6] = t2;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  return t3;
}